export default __webpack_public_path__ + "static/media/icon.42cd89c0.png";